export default "__VITE_ASSET__BFqXpoLJ__"